import { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_RESET_DELAY_MS = 1500;

export const useCopied = () => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const markCopied = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setCopied(true);
    timeoutRef.current = setTimeout(() => setCopied(false), COPIED_RESET_DELAY_MS);
  }, []);

  return { copied, markCopied };
};
